import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import IconChevronDownSmall from '../assets/icons/IconChevronDownSmall.vue'
import IconChevronUpSmall from '../assets/icons/IconChevronUpSmall.vue'
import IconChevronUpDownSmall from '../assets/icons/IconChevronUpDownSmall.vue'
import IconChevronUp from '../assets/icons/IconChevronUp.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ChevronToggle',
  props: {
    state: {},
    invert: { type: Boolean },
    medium: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (!_ctx.medium)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["chevron", { invert: _ctx.invert }])
      }, [
        (_ctx.state === 'down')
          ? (_openBlock(), _createBlock(IconChevronDownSmall, { key: 0 }))
          : (_ctx.state === 'up')
            ? (_openBlock(), _createBlock(IconChevronUpSmall, { key: 1 }))
            : (_openBlock(), _createBlock(IconChevronUpDownSmall, { key: 2 }))
      ], 2))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["chevron-medium", { invert: _ctx.invert }])
      }, [
        (_ctx.state === 'up')
          ? (_openBlock(), _createBlock(IconChevronUp, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.state === 'down')
          ? (_openBlock(), _createBlock(IconChevronUp, {
              key: 1,
              class: "rotated"
            }))
          : _createCommentVNode("", true)
      ], 2))
}
}

})